/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useState } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { useAuth } from "../../auth";
import Success from "./files/Success";

import ListSettlements from "./files/ListSettlements";
import AddSettlements from "./files/AddSettlements";
import DeleteSettlements from "./files/DeleteSettlements";
import { EditBasicDetailsWrapper } from "./files/EditWarpper";
import EditSuccess from "./files/EditSuccess";
import ViewTransaction from "./files/ViewTransaction";
import ViewSettlements from "./files/ViewSettlements";
import ViewWalletDetails from "./files/ViewTransaction";
import WalletDetails from "./files/walletDetails";
import SettlementDetails from "./files/settlementDetails";

const SettlementsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="/list"
          element={
            <>
              <ListSettlements />
            </>
          }
        />
        <Route
          path="/add"
          element={
            <>
              <AddSettlements />
            </>
          }
        />

        <Route
          path="/edit/:id"
          element={
            <>
              <EditBasicDetailsWrapper />
            </>
          }
        />
        <Route
          path="/delete/:id"
          element={
            <>
              <DeleteSettlements />
            </>
          }
        />
        <Route
          path="/success"
          element={
            <>
              <Success />
            </>
          }
        />
        <Route
          path="/editsuccess"
          element={
            <>
              <EditSuccess />
            </>
          }
        />
      

        <Route
          path="/all-wallet"
          element={
            <>
              <ViewWalletDetails />
            </>
          }
        />
        <Route
          path="/all-settlement"
          element={
            <>
              <ViewSettlements />
            </>
          }
        />
        <Route
          path="/wallet-details/:id"
          element={
            <>
              <WalletDetails />
            </>
          }
        />
        <Route
          path="/settlement-details/:id"
          element={
            <>
              <SettlementDetails />
            </>
          }
        />
        <Route index element={<Navigate to="list" />} />
      </Route>
    </Routes>
  );
};

export default SettlementsPage;
